import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import GetStartedPage from './pages/GetStartedPage';
import AppDownloadPage from './pages/AppDownloadPage';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import DeleteAccountPage from './pages/DeleteAccountPage';
import SupportPage from './pages/SupportPage';
import ScrollToTop from './components/ScrollToTop';

const App: React.FC = () => (
  <div className="app-container">
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/get-started" element={<GetStartedPage />} />
      <Route path="/app" element={<AppDownloadPage />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/support" element={<SupportPage />} />
      <Route path="/delete-account" element={<DeleteAccountPage />} />
    </Routes>
  </div>
);

export default App;
